import React from 'react';
import './CSS/CustomerSupport.css';

const CustomerSupport: React.FC = () => {
    return (
        <div className="customer-support-page">
            <div className="customer-support-container">
                <h2>Contact Customer Support</h2>
                <form className="customer-support-form">
                    <div className="form-group">
                        <input type="text" placeholder="First Name" className="input-half" />
                        <input type="text" placeholder="Last Name" className="input-half" />
                    </div>
                    <div className="form-group">
                        <input type="email" placeholder="Email Address" className="input-full" />
                    </div>
                    <div className="form-group">
                        <input type="text" placeholder="Company(Optional)" className="input-full" />
                    </div>
                    <div className="form-group">
                        <textarea placeholder="Message" className="input-full textarea-message"></textarea>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="connect-button">Let’s Connect</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CustomerSupport;
